registerComponent("modals/modal-contact", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * ⚠️ ESTE COMPONENTE NÃO RENDERIZA EM NENHUMA URL. O único call site
 * (`pages/home/index.blade.php:18`) está COMENTADO desde antes da reescrita, e
 * como o comentário Blade contém o texto da tag, o `UnreferencedComponentsTest`
 * o enxerga como call site e não acusa nada. Logo, nada aqui é exercitado pelo
 * `browser-check` nem pelos comparadores: o que prova este arquivo é o
 * `yarn lint`, o `node --check` do bundle, o grep de dependência legada e —
 * pelo lado do servidor — o caso `contato` do `FormsContractTest`. Candidato ao
 * protocolo de remoção da Fase 9, junto de `sections/home-videos`.
 *
 * ── POR QUE A VALIDAÇÃO CONTINUA AQUI, E NÃO EM `Asa.formulario` ───────────
 *
 * Os outros seis formulários do site usavam jQuery Validate; ESTE não. Ele
 * tinha validação à mão, em DUAS ETAPAS, disparada pelo clique em
 * `[data-next]` — nunca no `blur` —, marcando só a classe `error` no
 * `.box-input`, sem `label.error` e sem travar botão nenhum. Passar tudo para
 * `Asa.formulario` mudaria três coisas visíveis: o erro passaria a aparecer ao
 * sair do campo, entraria uma `label.error` que a folha não estiliza, e o
 * `.btn-modal` nasceria `disabled` — e `&:disabled` TEM regra na folha
 * (`.circle-next` escurece). O arquivo da Fase 7 prescreve `Asa.formulario(form,
 * { action, mascaras, regras })`; medido, não cabe. Correção registrada no
 * programa.
 *
 * O que `Asa.formulario` faz aqui é o que ele de fato substitui: a MÁSCARA de
 * telefone (a dinâmica de 2020, `jquery.mask`) e o ENVIO (o `$.post` com o
 * envelope que o programa fixou — `Accept: application/json`,
 * `X-Requested-With`, `X-CSRF-TOKEN`, `redirect: 'manual'` — e o contrato de
 * bandeira do `api/contatos`, 200 com `error: true`). As duas opções abaixo o
 * deixam fora do caminho da validação:
 *
 * · `regras: {}` e nenhum `[required]` no markup — não há o que validar, e o
 *   `atualizarEnvio()` nem chega a rodar porque nenhum botão do modal tem
 *   `type="submit"` escrito (`form.querySelector('[type="submit"]')` é `null`),
 *   que é justamente o que preserva o `disabled` manual do envio.
 * · `alvosDoEstado: () => []` — sem isto o `blur` limparia a classe `error`
 *   que a validação de etapa acabou de pôr no `.box-input`, porque para o
 *   `Asa.formulario` um campo sem regra é um campo válido.
 *
 * ── O QUE MUDA DE COMPORTAMENTO ───────────────────────────────────────────
 *
 * · **Falha de envio deixa de travar o modal.** Em 2020 o `.fail()` era vazio
 *   e o ramo `response.error === true` não fazia nada: o botão ficava
 *   `.sending` e `disabled` para sempre, sem mensagem. O `formulario:erro`
 *   devolve o botão ao estado normal. É a mesma decisão do 5c.
 * · O `window.addEventListener('scroll')` vira `Asa.aoRolar` (um listener e um
 *   quadro por rajada para a página inteira), e o disparo manual de `scroll`
 *   que o legado usava para medir na carga sai junto: `Asa.aoRolar` chama a
 *   função de imediato.
 * · O clique fora, que era `$body.on('click')` + `$(e.target).closest(component)`,
 *   passa a `document` + `Element.closest`.
 */

const hero = document.querySelector('[data-component-name="sections/hero"]');
const form = component.querySelector('#formContact');
const btnContact = component.querySelector('.btn-contact');
const fechar = component.querySelectorAll('[data-close]');
const proximos = component.querySelectorAll('[data-next]');
const trilha = component.querySelector('.slider-track');
const etapas = component.querySelector('.slider-steps');
const radios = component.querySelectorAll('.box-input input[type="radio"]');
const textos = component.querySelectorAll('.box-input input[type="text"]');

const isPt = document.documentElement.lang === 'pt-BR';

/**
 * A máscara dinâmica de 2020: 11 dígitos viram `(00) 00000-0000`, menos do que
 * isso fica em `(00) 0000-00009`. Só em pt, como no legado — em en o campo era
 * livre.
 */
const mascaraDoTelefone = (valor) => (valor.replace(/\D/g, '').length === 11
    ? '(00) 00000-0000'
    : '(00) 0000-00009');

Asa.formulario(form, {
    /*
     | `'api/contatos'` resolve contra o `document.baseURI`, que é o
     | `<base href="{{ url('/') }}/">` do layout legado — o mesmo destino que o
     | `${base}api/contatos` de 2020 montava.
     */
    action: 'api/contatos',
    mascaras: isPt ? { phone: mascaraDoTelefone } : {},
    alvosDoEstado: () => [],
});

let indice = 0;

/*
 | O botão flutuante aparece depois de passar a altura do hero. O legado media
 | `$hero.offsetHeight` UMA VEZ, na carga, e comparava a cada `scroll`; a conta
 | é a mesma, com o laço de quadro do `Asa.aoRolar` no lugar do listener.
 */
if (hero) {
    const alturaDoHero = hero.offsetHeight;

    Asa.aoRolar(() => {
        const topo = window.scrollY || document.documentElement.scrollTop;

        if (topo > alturaDoHero) {
            component.setAttribute('data-button-show', 'true');
        } else {
            component.removeAttribute('data-button-show');
        }
    });
}

const avancar = () => {
    indice += 1;

    trilha.style.left = `-${indice * 100}%`;
};

const marcar = (campo, erro) => campo.parentElement.classList.toggle('error', erro);

const fecharModal = () => {
    etapas.classList.remove('active');
    btnContact.classList.remove('hide');
    trilha.style.left = '0';

    radios.forEach((radio) => marcar(radio, false));

    indice = 0;

    document.activeElement.blur();
};

btnContact.addEventListener('click', () => {
    etapas.classList.add('active');
    btnContact.classList.add('hide');
});

/**
 * A primeira etapa: basta um segmento marcado.
 *
 * @returns {boolean}
 */
const primeiraEtapaValida = () => {
    const marcado = Array.from(radios).some((radio) => radio.checked);

    radios.forEach((radio) => marcar(radio, !marcado));

    return marcado;
};

/**
 * A segunda: nome não vazio, e-mail e — em pt — telefone no formato mascarado.
 * As três expressões são as de 2020, à letra.
 *
 * @returns {boolean}
 */
const segundaEtapaValida = () => {
    let ok = true;

    textos.forEach((campo) => {
        let erro = campo.value === '';

        if (!erro && campo.id === 'email') {
            erro = !/^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/.test(campo.value);
        }

        if (!erro && campo.id === 'telefone' && isPt) {
            erro = !/^\(\d{2}\) \d{4,5}-?\d{4}$/.test(campo.value);
        }

        marcar(campo, erro);

        if (erro) {
            ok = false;
        }
    });

    return ok;
};

proximos.forEach((botao) => {
    botao.addEventListener('click', function (evento) {
        /*
         | Os `.btn-modal` não têm `type` escrito, então são botões de ENVIO
         | dentro do `<form>`. O legado barrava o envio nativo aqui e mandava
         | pelo `$.post`; aqui o `preventDefault` continua, e quem manda é o
         | `requestSubmit()` lá embaixo, depois da validação da etapa — é o que
         | faz o `Asa.formulario` montar o `FormData` e disparar o `fetch`.
         */
        evento.preventDefault();

        if (this.dataset.next === 'first') {
            if (primeiraEtapaValida() && indice === 0) {
                avancar();
            }

            return;
        }

        if (!segundaEtapaValida()) {
            return;
        }

        this.classList.add('sending');
        this.disabled = true;

        form.requestSubmit();
    });
});

form.addEventListener('formulario:sucesso', () => {
    proximos.forEach((botao) => {
        botao.classList.remove('sending');
        botao.disabled = false;
    });

    form.reset();
    avancar();
});

/*
 | Em 2020 este caminho não existia: o `.fail()` era vazio e o `error: true`
 | caía no `if` sem `else`, deixando o botão preso em `.sending` e `disabled`.
 | Devolver o botão é o mínimo para o modal não morrer na tela de dados.
 */
form.addEventListener('formulario:erro', () => {
    proximos.forEach((botao) => {
        botao.classList.remove('sending');
        botao.disabled = false;
    });
});

fechar.forEach((botao) => botao.addEventListener('click', fecharModal));

radios.forEach((radio) => radio.addEventListener('click', avancar));

document.addEventListener('click', (evento) => {
    if (!evento.target.closest('[data-component-name="modals/modal-contact"]')) {
        fecharModal();
    }
});

});
